const Component = () => import('./FoodPreferences');

export { Component };
